import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { item } from '../items';
import { setting } from '../settings';
import { SettingsService } from '@scaffold/services/settings.service';
import { PropertiesService } from '../../services/properties.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-scaffold-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit, OnDestroy {
  comments_allowed = ['input', 'select', 'checkbox', 'switch', 'edit_text', 'connection', 'editor', 'radio'];
  model: string[];
  settings: any[];
  propertiesItem;
  hidden;
  comments;
  fileSet: boolean;
  destroy$: Subject<boolean> = new Subject<boolean>();
  parentView: any;
  @Output() closeDialog = new EventEmitter<string>();
  @Output() optionsChange = new EventEmitter<string>();
  constructor(private settingsService: SettingsService, public properties: PropertiesService, private dialogRef: NbDialogRef<OptionsComponent>) {

  }

  optionsUpdate(e: string) {
    this.closeDialog.emit(e);
  }

  setPropertiesSelection(item) {

    this.properties.setProperties(item);
    if (!item) {
      this.dialogRef.close();
    }

  }

  updateOptions(e) {
    console.log(e);
    this.properties.changeValue();
  }

  ngOnInit() {
    this.settingsService.getSettings().pipe(take(1)).subscribe(settings => {
      this.settings = settings;

      this.hidden = {
        label: "Hide in LMS",
        param: 'read_hidden',
        type: "checkbox"
      };
      this.comments = {
        label: "Allow Comments on Component",
        param: 'allow_comments',
        type: "checkbox",
        help: ""
      };
    });
    /*this.properties.watchProperties().pipe(takeUntil(this.destroy$)).subscribe(item => {
      this.parentView = this.properties.info;
      console.log(item);
      this.propertiesItem = item;
    });*/
    

    this.setFileSet();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  setFileSet() {
    if (this.parentView) {
      if (this.parentView.mode === 'view') {
        if (this.parentView.value && this.parentView.value.length > 0) {
          this.fileSet = this.parentView.value[0].file_data;
        }
      }
    }
  }
}
